import { GlButton, GlIcon, GlTooltipDirective } from '../../../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
import { FLOW_TRIGGER_MODE_SCHEDULE } from 'ee/ai/duo_agents_platform/constants';
import { flowTriggerEventSummary, flowTriggerModeFor } from 'ee/ai/duo_agents_platform/utils';
export default {
    name: 'FlowTriggerConditionRow',
    components: {
        GlButton,
        GlIcon
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    inject: {
        timezoneData: {
            default: ()=>[]
        }
    },
    props: {
        typeValue: {
            type: String,
            required: true
        },
        filter: {
            type: Object,
            required: false,
            default: ()=>({})
        },
        invalidFeedback: {
            type: String,
            required: false,
            default: null
        },
        isEditing: {
            type: Boolean,
            required: false,
            default: false
        },
        goal: {
            type: String,
            required: false,
            default: ''
        }
    },
    emits: [
        'edit',
        'remove'
    ],
    computed: {
        isSchedule () {
            return flowTriggerModeFor(this.typeValue) === FLOW_TRIGGER_MODE_SCHEDULE;
        },
        icon () {
            return this.isSchedule ? 'clock' : 'trigger-source';
        },
        summary () {
            return flowTriggerEventSummary(this.typeValue, {
                filter: this.filter,
                timezoneData: this.timezoneData
            });
        },
        editLabel () {
            return this.isSchedule ? s__('DuoAgentsPlatform|Edit schedule') : s__('DuoAgentsPlatform|Edit event');
        },
        removeLabel () {
            return this.isSchedule ? s__('DuoAgentsPlatform|Remove schedule') : s__('DuoAgentsPlatform|Remove event');
        }
    },
    i18n: {
        editing: s__('DuoAgentsPlatform|(editing)')
    }
};
